    <template>
            <div>
                <section>
                
                        <div class="bg-blue-800 bg-opacity-50">
                            <div class="mx-auto flex text-white justify-left sm:w-4/5 items-center">
                                <div class="text-left font-montserrat mx-5 z-10">
                                    <KeyPerformance />
                                    <h1 class="text-6xl font-black my-10 z-10">
                                        ERSTELLE DIE
                                        <br>
                                        WELTBESTEN
                                        <br> 
                                        KURSE ONLINE 
                                    </h1>
                                    <router-link to='/instructor-courses' class="py-5 rounded-b-lg px-10 text-xl bg-green-600 z-10">
                                        ERSTELLE KURSE
                                        <font-awesome-icon class="ml-3" :icon="['fas', 'arrow-right']" /> 
                                    </router-link>                      
                                </div>

                             <!--    <div class="text-8xl absolute rounded right-0 font-lato sm:block font-bold overflow-y-hidden w-1/2"> 
                                <img src="https://myedubbosz01.s3.eu-central-1.amazonaws.com/logo_Edu_trans_dda26c22e7.png" alt="" class="py-10 px-6">                       
                                </div> -->
                            </div>  
                        </div>
                        <!-- Autor Section -->

                        <router-link :to="'//registration-qms.vercel.app/register'" target="_blank">
                        <div class="block sm:flex my-20 justify-center items-center card py-10 w-full px-6">
             <!--            <div class="absolute top-20 left-0">
                            <img src="../assets/images/enrolled-student-1.png" alt="" class="opacity-70">
                        </div> -->
                  
                        <div class="z-10">
                            <div class="w-5/5 mx-auto text-left font-raleway z-10">
                            <h1 class="font-bold text-black text-6xl mb-10">
                                WERDE AUTOR
                                <br>
                                AUF DER EDUBB
                            </h1>
                             <h2 class="text-sm tracking-wide font-montserrat mb-10">
                                Erstelle Content Module und
                                <br>
                                nutze deine eigenen oder bereits <b>geprüfte</b>
                                <br>
                                <b>Lehrmaterialien</b>, aus der Praxis für die Praxis. Bewirb dich jetzt auf unserem digitalen Lehrerzimmer!
                             </h2>
                         
                                    <a class="text-xl mb-5 sm:mb-0 text-black font-bold font-raleway" :href="'//registration-qms.vercel.app/register'" target="_blank">
                                    AUTOR WERDEN 
                                    </a>
                                <font-awesome-icon class="" :icon="['fas', 'arrow-right']" />  

                            </div>
                        </div>
                        <br>
                        <div class="">
                            <div class="mx-auto ">
                            <img :href="'//registration-qms.vercel.app/register'" src="../assets/pages/401.png" alt="" class=""> 
                            </div>
                        </div>
                        </div>
                    </router-link>
                  
            <!-- <div class="relative"> -->
                <router-link :to="'//lehrerzimmer.io'" target="_blank">
                        <div class="block sm:flex my-20 justify-center items-center card py-10 w-full px-6">
             <!--            <div class="absolute top-20 left-0">
                            <img src="../assets/images/enrolled-student-1.png" alt="" class="opacity-70">
                        </div> -->
                  
                        <div class="z-10">
                            <div class="w-4/5 mx-auto text-left font-raleway z-10">
                            <h1 class="font-bold text-black text-6xl mb-10">
                                ALLE KURSE
                                <br>
                                SIND AUF QUALITÄT GEPRÜFT
                            </h1>
<!--                             <p class="text-sm tracking-wide font-montserrat mb-10">
                                Lorem ipsum dolor sit amet consectetur adipisicing elit. 
                                <br>
                                Facilis ex iure rem vero voluptate, sint praesentium quidem,
                                <br>
                                eius sequi, officia itaque? Eveniet quaerat eos qui sunt suscipit nisi sequi? Soluta.
                            </p> -->
                         
                                    <a class="text-xl mb-5 sm:mb-0 text-black font-bold font-raleway" :href="'//lehrerzimmer.io'" target="_blank">
                                    QUALITÄTSMANAGEMENT 
                                    </a>
                                <font-awesome-icon class="" :icon="['fas', 'arrow-right']" />  

                            </div>
                        </div>
                        <br>
                        <div class="">
                            <div class="mx-auto rounded-full w-4/5 bg-purple-900 p-20">
                            <img :href="'//lehrerzimmer.io'" src="https://www.lehrerzimmer.io/2u6jlI01.svg" alt="" class=""> 
                            </div>
                        </div>
                        </div>
                    </router-link>
                    <!-- </div> -->
                </section>
            </div>
        </template>

        <script>
   import KeyPerformance from '../components/KeyPerformance.vue'

            export default {
                name: "HeroSection",
                components:{
                    KeyPerformance
                }
            }
        </script>
        <style scoped>
        </style>